import { AnyAction, CombinedState, combineReducers, Reducer } from 'redux'
import { connectRouter, RouterState } from 'connected-react-router'
import { History } from 'history'
import bienAVendreSlice, {
  BienAVendreState,
} from './features/bienAVendre/slice'
import parcelleSlice, { ParcelleState } from './features/parcelle/slice'
import mapSlice, { MapState } from './features/map/slice'
import etudierMarcheSlice, {
  EtudierMarcheState,
} from './features/etudierMarche/slice'
import favorisSlice, { FavorisState } from './features/favoris/slice'
import dvfSlice, { DvfState } from './features/dvf/slice'
import userSlice, { UtilisateurState } from './features/utilisateur/slice'
import filterResultSlice, {
  FilterResultState,
} from './features/filterResult/slice'

export interface AppState {
  router: RouterState<unknown>
  [bienAVendreSlice.name]: BienAVendreState
  [etudierMarcheSlice.name]: EtudierMarcheState
  [dvfSlice.name]: DvfState
  [parcelleSlice.name]: ParcelleState
  [mapSlice.name]: MapState
  [favorisSlice.name]: FavorisState
  [userSlice.name]: UtilisateurState
  [filterResultSlice.name]: FilterResultState
}

const createRootReducer = (
  history: History
): Reducer<CombinedState<AppState>, AnyAction> =>
  combineReducers<AppState>({
    router: connectRouter(history),
    [bienAVendreSlice.name]: bienAVendreSlice.reducer,
    [etudierMarcheSlice.name]: etudierMarcheSlice.reducer,
    [dvfSlice.name]: dvfSlice.reducer,
    [parcelleSlice.name]: parcelleSlice.reducer,
    [mapSlice.name]: mapSlice.reducer,
    [favorisSlice.name]: favorisSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [filterResultSlice.name]: filterResultSlice.reducer,
  })

export default createRootReducer
